import { css as i } from "lit";
var l = i`:host{display:flex}:host([inline]){display:inline-flex}`;
export { l as default };